"use client"

// Shared "table is refetching" affordances, used by Product Economics,
// Bundle Matrix and the standalone-decompose Sheet so a stale-while-revalidate
// refetch shows a consistent indicator instead of an abrupt content swap.

import { Loader2 } from "lucide-react"

/** Inline "Updating…" pill — drop into a header / row-count line. */
export function TableUpdatingPill({
  active,
  label = "Updating…",
}: {
  active: boolean
  label?: string
}) {
  if (!active) return null
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full border border-blue-200 bg-blue-50 px-2 py-0.5 text-[11px] font-medium text-blue-700 dark:border-blue-900 dark:bg-blue-950/40 dark:text-blue-300"
      role="status"
      aria-live="polite"
    >
      <Loader2 className="h-3 w-3 animate-spin" />
      {label}
    </span>
  )
}

/**
 * Indeterminate top progress bar. Must be placed inside a `relative`
 * container (e.g. the table wrapper) — it pins to the top edge.
 */
export function TableUpdatingBar({ active }: { active: boolean }) {
  if (!active) return null
  return (
    <div
      className="pointer-events-none absolute inset-x-0 top-0 h-0.5 overflow-hidden rounded-t-md"
      aria-hidden
    >
      <div className="h-full w-1/3 animate-loading-bar bg-blue-500/70" />
    </div>
  )
}
